<template>
    <v-container>
        <div>
            <div class="mainHTML">
                <div class="swiper-item">
                    <test></test>
                    <div class="topLog">
                        <el-image
                                :src="require('../img2/clf/logo2021.png')"
                                ></el-image>
                    </div>
                </div>

                <div class="menu">
                    <a v-for="item in heedIfo">
                        <img  :src="item.imgUrl" class="listitemimage"  @click="linkFun(item)"/>
                    </a>
                    <a href="http://test.hi916.com/index.php?m=home&c=Map&a=index">
                        <img  :src="require('../img2/spf/dtzf.png')" class="listitemimage" />
                    </a>
                </div>
            </div>
        </div>
    </v-container>
</template>
<script>
    import Test from "../views/test";
    export default {
        name: "Shouye",
        components: {Test},
        data() {
            return{
                heedIfo:[
                    {
                        href: '/ywhome/spfhome',
                        imgUrl: require("../img2/spf/spflogo2.png"),
                        title: '商品房',
                        id:"1"
                    },
                    {
                        href: '/ywhome/clfhome',
                        imgUrl: require("../img2/spf/存量房.png"),
                        title: '存量房',
                        id:"2"
                    },
                    {
                        href: '/ywhome/zlfhome',
                        imgUrl: require("../img2/spf/租赁房.png"),
                        title: '租赁房',
                        id:"3"
                    },
                    {
                        href: '/ywhome/jjglhome',
                        imgUrl: require("../img2/spf/经济管理.png"),
                        title: '经纪管理',
                        id:"4"
                    },
                    {
                        href: '/ywhome/xxcxhome',
                        imgUrl: require("../img2/spf/编组 6.png"),
                        title: '信息查询',
                        id:"5"
                    },
                    {
                        href: '/ywhome/zcfghome',
                        imgUrl: require("../img2/spf/政策法规.png"),
                        title: '政策法规',
                        id:"6"
                    },
                    {
                        href: '/ywhome/bgxzhome',
                        imgUrl: require("../img2/spf/编组 7.png"),
                        title: '表格下载',
                        id:"7"
                    }
                ]
            }
        },
        methods: {
            copy(e) {
                // handleClipboard(e.target.innerHTML, e);
            },
            warnMessage(obj) {
                this.$alert(obj, '温馨提示', {
                    confirmButtonText: '确定',
                });
            },
            linkFun(item){
                if(item.href=="/ywhome/zlfhome"){
                    this.warnMessage("功能正完善中...");
                }else{
                    this.$router.push({path:item.href,query:{id:item.href}})
                }
            }
        },
        mounted(){
            new Swiper ('.swiper-container', {
                loop: true,
                // 如果需要分页器
                pagination: '.swiper-pagination',
                // 如果需要前进后退按钮
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev',
                // 如果需要滚动条
                scrollbar: '.swiper-scrollbar',
            })
        }
    };
</script>
<style scoped>
    .menu{
        display: flex;
        flex-flow:row wrap;
    }
    .menu .img{
        display: inline-block;
        margin-right: 30px;
    }
    /*移动端*/
    @media screen and (max-width: 414px) {
        .menu{
            width: 94%;
            margin: 20px auto;
        }

        .menu a{
            margin-top: 10%;
            width: 50%;
        }
        .menu img{
            width: 100%;
        }
        .v-application{
            background-color: antiquewhite !important;
        }
    }
    /*PC端*/
    @media screen and (min-width: 414px) {
        .menu{
            width: 1000px;
            margin:30px auto;
        }

        .menu img{
            width: 230px;
            margin-right: 18px;
            margin-top:10px;
        }
    }

    .container{
        max-width: 100% !important;
        padding: 0 !important;
    }

    .listitemimage:hover{
        transform: scale(1.07);
        transition: all 0.5s;
    }
    /*设置log置顶*/
    .topLog{
        text-align: center;
        position: absolute;
        top: 0;
        left: 50%;
        opacity: 1;
        background: rgba(255,255,255,0.30);
        width: 100%;
        transform: translateX(-50%);
        z-index: 100;
    }

    .swiper-item{
        position: relative;
    }
</style>
<style scoped>
    ::-webkit-scrollbar {
        width: 0 !important;
    }
    ::-webkit-scrollbar {
        width: 0 !important;height: 0;
    }
</style>
<style>
    .v-application--wrap{
        width: 100% !important;
    }
    .topLog .el-image__inner--center{
        top:0 !important;
        left:0 !important;
        transform:none !important;
    }
</style>
